<template>
  <v-row id="pointsPurchaseHistory" no-gutters class="ml-md-12 my-6">
    <div class="body-heading-large mb-6">Point Purchase History</div>
    <v-data-table id="pointPurchaseHistoryTable" :page.sync="page" :headers="headers" :items="pointsPurchaseHistoryList" :items-per-page="itemsPerPage" class="full-width" :no-data-text="noDataText" @page-count="pageCount = $event" hide-default-footer :hide-default-header="isMobile">
      <template v-slot:item.note="{ item }">
        <div>{{ parseNote(item.note) }}</div>
      </template>
      <template v-slot:item.total_price="{ item }">
        <div>{{ parsePrice(item.total_price) }}</div>
      </template>
      <template v-slot:item.purchased_at="{ item }">
        <div>{{ parsePaymentDate(item.purchased_at) }}</div>
      </template>
      <template v-slot:item.payment_method="{ item }">
        <PaymentCardField :card="item.payment_method" class="mx-0" />
      </template>
    </v-data-table>
    <v-col cols="12" md="12">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </v-col>
  </v-row>
</template>

<script>
  import PaymentCardField from "@/components/Payment/PaymentCardField";

  export default {
    name: "PointsPurchaseHistory",

    data() {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        headers: [
          {
            text: "Date",
            value: "purchased_at",
            sortable: false,
          },
          {
            text: "Point Amount",
            value: "points",
            sortable: false,
          },
          {
            text: "Payment Amount (CAD)",
            value: "total_price",
            sortable: false,
          },
          //FIXME: API should return this
          //{
          //text: "Payment Method",
          //value: "payment_method",
          //sortable: false,
          //},
          {
            text: "Note",
            value: "note",
            sortable: false,
            width: "20%",
          },
        ],
        pointsPurchaseHistoryList: [],
        noDataText: "No Point Purchase History Records",
      };
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },

    components: { PaymentCardField },

    methods: {
      parseNote(note) {
        if (this.$validator.isNil(note) || note === "N/A") {
          return "N/A";
        }
      },

      parsePaymentDate(date) {
        return this.$moment(date).format("YYYY-MM-DD");
      },

      parsePrice(price) {
        return this.$converter.centsToDollarsWithoutRounding(price);
      },
    },

    created() {
      this.$store.commit("setLoadingStatus", true);

      this.$http
        .get("/payments")
        .then((response) => {
          this.pointsPurchaseHistoryList = response.data.payments;

          this.$store.commit("setLoadingStatus", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setError", {
            message: this.$formatter.getErrorMsg(error),
            type: "error",
          });
          this.$store.commit("setLoadingStatus", false);
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Points/PointsPurchaseHistory.vue